import { trackPageLoad } from "@asosteam/asos-content-web-analytics";
import sdkProvider from "./sdk-provider";
import analyticsProvider from "../analyticsProvider";
import getUserLoginStatus from "./getUserLoginStatus";
import hasJustLoggedIn from "../../../../shared/hasJustLoggedIn";

/* eslint-disable complexity */
export const trackPageEvent = async ({ content = {} }) => {
  try {
    const { layout, pageName } = content;
    const identity = await sdkProvider("identity");
    const userProfile = await identity.customer.profile();
    const customerId = await identity.customer.customerId();
    const isRecognised = (await identity.customer.isRecognised?.()) || false;
    const isAuthenticated = await identity.customer.isAuthenticated();

    const { platform = "", storeId = "" } =
      window.asos.webContext.getWebContext();
    const server = `${platform} ${storeId.toLowerCase()}`;
    const pageLoadProperties = {
      server,
      customerId,
      loginStatus: getUserLoginStatus({ isAuthenticated, isRecognised }),
      extraProps: {},
      pageName,
    };

    if (layout === "student-verification-page-load") {
      const { loginPrompted, verificationStatus } = content;
      if (loginPrompted) {
        let sProp29Value = "";
        if (isAuthenticated) {
          const isFirstLogin =
            userProfile.lastAction.isSignupEmail ||
            userProfile.lastAction.isSignupSocial;

          //  document?.referrer.includes("web/pages/identity-redirect") to be removed as soon as we're sure that the new logic (Identity V2) is working as expected
          const isComingFromIdentity =
            document?.referrer.includes("web/pages/identity-redirect") ||
            hasJustLoggedIn();

          sProp29Value =
            isFirstLogin && isComingFromIdentity
              ? "student verification successful sign up" //Scenario 7
              : "student verification successful login"; //Scenario 8
        }
        pageLoadProperties.extraProps.prop29 = sProp29Value;
      }
      if (verificationStatus) {
        pageLoadProperties.extraProps.eVar106 = `student verification|${verificationStatus}|message`;
        pageLoadProperties.extraProps.eventVars = {
          event172: "event172",
        };
      }
      const config = analyticsProvider(layout, pageLoadProperties);
      await trackPageLoad(config);
    }
  } catch (e) {
    throw new Error(e);
  }
};
